export const EXEC_VOCALASSISTANT_ACTION = 'EXEC_VOCALASSISTANT_ACTION';
export const FIND_CALL_NUMBER_REQUEST = 'FIND_CALL_NUMBER_REQUEST';
export const FIND_CALL_NUMBER_SUCCESS = 'FIND_CALL_NUMBER_SUCCESS';
export const FIND_CALL_NUMBER_FAILURE = 'FIND_CALL_NUMBER_FAILURE';
